/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-06-21 17:25:33
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-21 16:22:08
 */
import { RouteRecordRaw } from 'vue-router'
import AIPointLayout from '@/layouts/AIPointLayout/index.vue'
import BaseLayout from '@/layouts/BaseLayout/index.vue'
import NoneLayout from '@/layouts/NoneLayout/index.vue'
// import OpenLessLayout from '@/layouts/OpenLessLayout/index.vue'
import { RouterNameEnum } from '@/enums/routerEnum'

const {
  LOGIN_ROUTER_NAME,
  BASE_SERVER_ROUTER_NAME,
  BASE_SERVER_USER_ROUTER_NAME,
  BASE_SERVER_ROLE_ROUTER_NAME,
  SETTING_ROUTER_NAME,
  SETTING_ROUTER_BASIC__NAME,
  ROOT_ROUTER_NAME,
  ADD_AUTH_KEY,
  LICENSE_DETAIL,
  OPERATE_CENTER,
  REMOTE_APPLICATION,
  APPLICATION_AUTH,
  APPLICATION_MANAGEMENT,
  APPLICATION_KEY,
  ONLINE_SHOP_ROUTER_NAME,
  ALGORITHM_SHOP_ROUTER_NAME,
  ALGORITHM_GROUP_ROUTER_NAME,
  APP_SHOP_ROUTER_NAME,
  SYSTEM_SERVICE_ROUTER_NAME,
  SYSTEM_LOG_ROUTER_NAME,
  REMOTE_APPLICATION_DETAILS,
  APP_SHOP_DETAILS_ROUTER_NAME,
  ALGORITHM_DETAILS_ROUTER_NAME,
  SYSTEM_USER_ROUTER_NAME,
  CRRS,
  FILE_UPLOAD,
  FILE_DOWNLOAD,
  FILE_PUBLISH,
  FILE_PUBLISH_UPLOAD,
  FILE_PUBLISH_DOWNLOAD,
  FILE_PUBLISH_CENTER,
  CRRS_CENTER,
  FEEDBACK,
  BLUEPRINT_ASSISTANT_FEEDBACK,
  DOWNLOAD_PLUGIN,
  WELCOME,
  WELCOME_INDEX
  // OPEN_LESS_ROUTER_NAME,
  // OPEN_LESS_EXTENDED_APPLICATION_ROUTER_NAME,
  // OPEN_LESS_EXTERNAL_ACCESS_ROUTER_NAME
} = RouterNameEnum

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/root'
  },
  {
    path: '/login',
    name: LOGIN_ROUTER_NAME,
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/root',
    name: ROOT_ROUTER_NAME,
    meta: {
      title: 'root'
    },
    component: () => import('@/views/root/index.vue')
  },
  {
    path: '/welcome',
    name: WELCOME,
    // component: () => import('@/views/welcome/index.vue'),
    component: BaseLayout,
    meta: {
      isHideMenu: true,
      title: 'welcome'
    },
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: WELCOME_INDEX,
        component: () => import('@/views/welcome/index.vue'),
        meta: {
          isHideMenu: true,
          title: 'welcome'
        }
      }
    ]
  },
  {
    path: '/operate_center',
    name: OPERATE_CENTER,
    meta: {
      title: '运营中心',
      isHeaderMenu: true,
      activeMenu: OPERATE_CENTER
    },
    component: BaseLayout,
    redirect: '/application-management/remote-application',
    children: [
      {
        path: '/application-management',
        name: APPLICATION_MANAGEMENT,
        component: NoneLayout,
        meta: {
          title: '应用管理',
          activeMenu: OPERATE_CENTER
        },
        redirect: '/application-management/remote-application',
        children: [
          {
            path: 'remote-application',
            name: REMOTE_APPLICATION,
            component: () => import('@/views/application-management/remote-application/index.vue'),
            meta: {
              title: '远程应用',
              icon: 'color-remote-app-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'app-detail/:appId',
            name: REMOTE_APPLICATION_DETAILS,
            component: () => import('@/views/application-management/remote-application/detail.vue'),
            meta: {
              title: '远程应用详情',
              icon: 'color-remote-app-def',
              activeMenu: OPERATE_CENTER,
              isHideMenu: true
            }
          },
          {
            path: 'key',
            name: APPLICATION_KEY,
            component: () => import('@/views/application-management/key/index.vue'),
            meta: {
              title: '应用密钥',
              icon: 'color-license-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'auth',
            name: APPLICATION_AUTH,
            component: () => import('@/views/application-management/auth/index.vue'),
            meta: {
              title: '应用授权',
              icon: 'color-key-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'add-license',
            name: ADD_AUTH_KEY,
            component: () => import('@/views/application-management/add-license/index.vue'),
            meta: {
              title: '添加应用授权',
              icon: 'color-user-label-def',
              activeMenu: OPERATE_CENTER,
              isHideMenu: true
            }
          },
          {
            path: 'license-detail',
            name: LICENSE_DETAIL,
            meta: {
              title: 'License 详情',
              isHideMenu: true,
              activeMenu: OPERATE_CENTER
            },
            component: () => import('@/views/application-management/license-detail/index.vue')
          }
        ]
      },
      {
        path: '/file-publish',
        name: FILE_PUBLISH,
        meta: {
          title: '产品发布',
          activeMenu: OPERATE_CENTER
        },
        component: NoneLayout,
        redirect: '/file-publish/file-upload',
        children: [
          {
            path: 'file-upload',
            name: FILE_UPLOAD,
            meta: {
              title: '文件上传',
              icon: 'file-upload-def',
              activeMenu: OPERATE_CENTER,
              openURL: 'storage/publish/auth' // 如果需要点击按钮新标签打开页面
            },
            // component: NoneLayout
            component: () => import('@/views/system-server/crrs/upload-new.vue')
          },
          // {
          //   path: 'file-download',
          //   name: FILE_DOWNLOAD,
          //   meta: {
          //     title: '文件下载',
          //     icon: 'file-download-def',
          //     activeMenu: OPERATE_CENTER
          //   },
          //   component: () => import('@/views/system-server/crrs/download-new.vue')
          // },
          {
            path: 'file-download',
            name: FILE_DOWNLOAD,
            meta: {
              title: '文件下载',
              icon: 'file-download-def',
              activeMenu: OPERATE_CENTER
            },
            component: () => import('@/views/system-server/crrs/download-server/index.vue')
          }
        ]
      },
      {
        path: '/online-shop',
        name: ONLINE_SHOP_ROUTER_NAME,
        meta: {
          title: '在线商店',
          activeMenu: OPERATE_CENTER
        },
        component: NoneLayout,
        redirect: '/online-shop/algorithm-shop',
        children: [
          {
            path: 'app-store',
            name: APP_SHOP_ROUTER_NAME,
            component: () => import('@/views/online-store/app-store/index.vue'),
            meta: {
              title: '应用商店',
              icon: 'color-store-app-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'algorithm-shop',
            name: ALGORITHM_SHOP_ROUTER_NAME,
            component: () => import('@/views/online-store/algorithms-store/index.vue'),
            meta: {
              title: '算法商店',
              icon: 'color-store-algorithm-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'algorithm-group',
            name: ALGORITHM_GROUP_ROUTER_NAME,
            component: () => import('@/views/online-store/algorithms-group/index.vue'),
            meta: {
              title: '算法分组',
              icon: 'color-group-algorithm-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'app-shop-detail',
            name: APP_SHOP_DETAILS_ROUTER_NAME,
            meta: {
              title: '应用商店详情',
              isHideMenu: true,
              activeMenu: OPERATE_CENTER
            },
            component: () => import('@/views/online-store/app-detail/index.vue')
          },
          {
            path: 'algorithm-detail',
            name: ALGORITHM_DETAILS_ROUTER_NAME,
            meta: {
              title: '算法详情',
              isHideMenu: true,
              activeMenu: OPERATE_CENTER
            },
            component: () => import('@/views/online-store/algorithms-detail/index.vue')
          }
        ]
      },
      {
        path: '/system-service',
        name: SYSTEM_SERVICE_ROUTER_NAME,
        component: NoneLayout,
        meta: {
          title: '系统服务',
          icon: 'color-user-label-def',
          activeMenu: OPERATE_CENTER
        },
        children: [
          {
            path: 'system-log',
            name: SYSTEM_LOG_ROUTER_NAME,
            component: () => import('@/views/system-server/logs/index.vue'),
            meta: {
              title: '系统日志',
              icon: 'color-note-system-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'crrs',
            name: CRRS,
            component: () => import('@/views/system-server/crrs/index.vue'),
            meta: {
              title: 'CRRS',
              icon: 'color-save-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'app-feedback',
            name: FEEDBACK,
            component: () => import('@/views/app-feedback/index.vue'),
            meta: {
              title: 'App问题反馈',
              icon: 'color-note-system-def',
              activeMenu: OPERATE_CENTER
            }
          },
          {
            path: 'blueprint-assistant-feedback',
            name: BLUEPRINT_ASSISTANT_FEEDBACK,
            component: () => import('@/views/blueprint-assistant-feedback/index.vue'),
            meta: {
              title: '蓝图助手问题反馈',
              icon: 'color-note-system-def',
              activeMenu: OPERATE_CENTER
            }
          }
        ]
      }
    ]
  },
  {
    path: '/base-server',
    name: BASE_SERVER_ROUTER_NAME,
    meta: {
      title: '系统用户',
      isHeaderMenu: true,
      activeMenu: BASE_SERVER_ROUTER_NAME
    },
    component: BaseLayout,
    redirect: '/user-system/user',
    children: [
      {
        path: '/user-system',
        name: SYSTEM_USER_ROUTER_NAME,
        component: NoneLayout,
        meta: {
          title: '系统用户',
          icon: 'color-user-label-def',
          activeMenu: BASE_SERVER_ROUTER_NAME
        },
        redirect: '/user-system/user',
        children: [
          {
            path: 'user',
            name: BASE_SERVER_USER_ROUTER_NAME,
            component: () => import('@/views/base-server/user/index.vue'),
            meta: {
              title: '用户管理',
              icon: 'color-user-def',
              activeMenu: BASE_SERVER_ROUTER_NAME
            }
          },
          {
            path: 'role',
            name: BASE_SERVER_ROLE_ROUTER_NAME,
            component: () => import('@/views/base-server/role/index.vue'),
            meta: {
              title: '角色管理',
              icon: 'color-user-label-def',
              activeMenu: BASE_SERVER_ROUTER_NAME
            }
          }
        ]
      }
    ]
  },
  {
    path: '/CRRS-center',
    name: CRRS_CENTER,
    meta: {
      title: '鲲云产品文件发布中心',
      isHeaderMenu: false,
      activeMenu: CRRS_CENTER
    },
    component: NoneLayout,
    redirect: '/CRRS-center/crrs-upload',
    children: [
      {
        path: 'crrs-upload',
        name: FILE_PUBLISH_UPLOAD,
        meta: {
          title: '上传',
          isHideMenu: true,
          noAuth: true
        },
        component: () => import('@/views/system-server/crrs/upload-new.vue')
      },
      {
        path: 'plugin-download',
        name: DOWNLOAD_PLUGIN,
        meta: {
          title: '插件下载',
          isHeaderMenu: true
        },
        component: () => import('@/views/system-server/crrs/plugin.vue')
      }
    ]
  },
  // {
  //   path: '/open-ness',
  //   name: OPEN_LESS_ROUTER_NAME,
  //   meta: {
  //     title: '开放能力',
  //     isHeaderMenu: true,
  //     activeMenu: '/open-ness'
  //   },
  //   component: OpenLessLayout,
  //   redirect: '/open-ness/extended-application',
  //   children: [
  //     {
  //       path: 'extended-application',
  //       name: OPEN_LESS_EXTENDED_APPLICATION_ROUTER_NAME,
  //       component: () => import('@/views/open-ness/extended-application/index.vue'),
  //       meta: {
  //         title: '扩展应用',
  //         icon: 'plugins-line',
  //         activeMenu: '/open-ness'
  //       }
  //     },
  //     {
  //       path: 'external-access',
  //       name: OPEN_LESS_EXTERNAL_ACCESS_ROUTER_NAME,
  //       component: () => import('@/views/open-ness/external-access/index.vue'),
  //       meta: {
  //         title: '对外接入',
  //         icon: 'flow-data-line',
  //         activeMenu: '/open-ness'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/setting',
    name: SETTING_ROUTER_BASIC__NAME,
    meta: {
      title: '系统设置'
    },
    component: AIPointLayout,
    children: [
      {
        path: '',
        name: SETTING_ROUTER_NAME,
        component: () => import('@/views/setting/index.vue'),
        meta: {
          title: '系统设置'
        }
      }
    ]
  },
  {
    path: '/test',
    name: 'test',
    meta: {
      title: 'test',
      noAuth: true
    },
    component: () => import('@/views/test/test')
  },
  {
    path: '/403',
    name: '403',
    meta: {
      title: '403'
    },
    component: AIPointLayout,
    children: [
      {
        path: '',
        name: '403',
        component: () => import('@/views/403/index.vue'),
        meta: {
          title: '403'
        }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/views/404/index.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    meta: {
      title: '404'
    },
    component: () => import('@/views/404/index.vue')
  }
]

export default routes
